import { Params } from '@angular/router';

/**
 * Canonical target for an `/embed/...` page: the public page it mirrors, so Google
 * merges the iframe copy into the original instead of indexing it twice (#359).
 *
 * Returns `undefined` for embeds whose component manages its own head tags:
 * the job detail (canonical on `/jobs/{id}`) and the apply form (noindex, no canonical).
 */
export function embedCanonicalPath(
  path: string,
  query: Params
): string | undefined {
  const segments = path.split(/[?#]/)[0].split('/').filter(Boolean);
  if (segments[0] !== 'embed') return undefined;
  const [, section, id, ...rest] = segments;

  if (section === 'jobs') {
    if (id) return undefined;
    const schoolId = query['schoolId'] || query['schoolRootId'];
    return schoolId ? `/schools/${schoolId}` : '/jobs';
  }
  if (section === 'jobs-with-filters') return '/jobs';
  if (section === 'schools') {
    if (id && rest.length === 0) return `/schools/${id}`;
    return id ? undefined : '/schools';
  }
  if (section === 'schools-with-filters') return '/schools';
  return undefined;
}
